import i18next from 'i18next';

export default function initI18n(): void {
  i18next.addResourceBundle('en', 'taxonomy-ui', {
    bookNotFound: 'Book not found',
    copiesSold: 'Copies Sold:',
    podEpisodeNotFound: 'PodEpisode not found',
    audioNotSupported: 'Your browser does not support the audio element.',
    videoNotSupported: 'Your browser does not support the video element.',
    viewEpisodePage: 'View Episode Page',
    detailsNotAvailableForItemType: 'Details not available for item type:',
    videoNotFound: 'Video not found',
    captionsAvailable: 'Captions Available',
    editBioSummary: 'Edit Bio & Summary',
    saveBioSummary: 'Save Bio & Summary',
    cancelChanges: 'Cancel Changes',
    publishSelectedAuthors: 'Publish selected authors',
    unpublishSelectedAuthors: 'Unpublish selected authors',
    deleteSelectedAuthors: 'Delete selected authors',
    editAuthor: 'Edit author',
    openInEditor: 'Open in editor',
    deleteAuthor: 'Delete author',
    publishSelectedLifeDomains: 'Publish selected life domains',
    unpublishSelectedLifeDomains: 'Unpublish selected life domains',
    lifeDomains: 'Life Domains',
    resourceLinks: 'Resource Links',
    editDescription: 'Edit Description',
    saveDescription: 'Save Description',
    deleteResource: 'Delete resource',
    openDataUrl: 'Open data URL',
    openResourceLink: 'Open resource link',
    deleteResourceLink: 'Delete resource link',
    noRating: 'No rating',
    taxonomyDetails: 'Taxonomy Details',
    publishSelectedTaxonomies: 'Publish selected taxonomies',
    unpublishSelectedTaxonomies: 'Unpublish selected taxonomies',
    deleteSelectedTaxonomies: 'Delete selected taxonomies',
    deleteTaxonomy: 'Delete taxonomy',
    taxonomySearchLogs: 'Taxonomy search logs',
    uploadLifeDomainJson: 'Upload Life Domain JSON',

    // Generic actions (reused across confirm dialogs)
    delete: 'Delete',
    cancel: 'Cancel',
    deleteCannotBeUndoneSuffix: ' This action cannot be undone.',

    // AuthorGrid
    author: 'Author',
    authors: 'Authors',
    deleteAuthorConfirmTitle: 'Delete Author',
    deleteAuthorConfirmDescription:
      'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
    authorUpdated: 'Author updated',
    authorDeleted: 'Author deleted',
    authorPublished: 'Author published',
    authorUnpublished: 'Author unpublished',
    failedToUpdateAuthorPublishStatus: 'Failed to update publish status',
    authorsDeletedCount: 'Deleted {{count}} author',
    authorsDeletedCount_plural: 'Deleted {{count}} authors',

    // LifeDomainGrid
    lifeDomain: 'Life Domain',
    lifeDomainPublished: 'Life domain published',
    lifeDomainUnpublished: 'Life domain unpublished',

    // ResourceItemDetailPanel / ResourceLinkDetailPanel
    descriptionUpdatedSuccess: 'Description updated successfully',

    // ResourceItemGrid / ResourceItemSubGrid
    resourceDeleted: 'Resource deleted',
    resourcePublished: 'Resource published',
    resourceUnpublished: 'Resource unpublished',
    deleteResourceConfirmTitle: 'Delete Resource',
    deleteResourceConfirmDescription:
      'Are you sure you want to delete "{{title}}"? This action cannot be undone.',

    // ResourceLinkGrid
    resourceLinkDeleted: 'Resource link deleted',
    resourceLinkPublished: 'Resource link published',
    resourceLinkUnpublished: 'Resource link unpublished',
    deleteResourceLinkConfirmTitle: 'Delete Resource Link',
    deleteResourceLinkConfirmDescription:
      'Are you sure you want to delete this resource link from {{platform}}? This action cannot be undone.',

    // TaxonomyGrid / TaxonomySubGrid
    taxonomy: 'Taxonomy',
    taxonomies: 'Taxonomies',
    taxonomyDeleted: 'Taxonomy deleted',
    taxonomiesDeletedCount: '{{count}} taxonomy deleted',
    taxonomiesDeletedCount_plural: '{{count}} taxonomies deleted',
    taxonomyPublished: 'Taxonomy published',
    taxonomyUnpublished: 'Taxonomy unpublished',
    deleteTaxonomyConfirmTitle: 'Delete Taxonomy',
    deleteTaxonomyConfirmDescription:
      'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
    publishTaxonomyConfirmTitle: 'Publish Taxonomy',
    unpublishTaxonomyConfirmTitle: 'Unpublish Taxonomy',
    publishTaxonomyConfirmDescription: 'Are you sure you want to publish "{{name}}"?',
    unpublishTaxonomyConfirmDescription: 'Are you sure you want to unpublish "{{name}}"?',
    publishResTaxonomyConfirmTitle: 'Publish ResTaxonomy',
    unpublishResTaxonomyConfirmTitle: 'Unpublish ResTaxonomy',
    resTaxonomyPublished: 'ResTaxonomy published',
    resTaxonomyUnpublished: 'ResTaxonomy unpublished',
  });
}
